<template>
  <svg
    height="22px"
    width="22px"
  >
    <path :d="icon" />
  </svg>
</template>
<script setup lang="ts">


interface Props {
  icon?:string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(),{
  icon:undefined
  }

)

</script>

<style scoped>
.sog-icon {
  fill: currentColor;
}
</style>
